var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.2857,
    height: 54.2857,
    rx: 27.1429,
    fill: "url(#paint0_linear_287_6248)",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.565476,
    y: 0.565476,
    width: 53.1548,
    height: 53.1548,
    rx: 26.5774,
    stroke: "url(#paint1_linear_287_6248)",
    strokeOpacity: 0.2,
    strokeWidth: 1.13095
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5084 18.0025L27.1942 18L29.0264 18.0241L30.1971 18.0508L31.4453 18.0908L32.2865 18.1262L33.1109 18.1695L33.8983 18.2216C34.9143 18.2973 35.7767 18.3984 36.2672 18.5334C37.3436 18.8273 38.1899 19.6962 38.4787 20.8079C38.5865 21.2219 38.6721 21.7283 38.74 22.2715L38.8133 22.9373C38.8351 23.1628 38.8544 23.3905 38.8715 23.617L38.934 24.6154L38.9619 25.2358L38.996 26.4722L39 27.2009L38.9808 28.1933L38.9492 29.0587L38.8954 30.0377C38.8731 30.3749 38.846 30.719 38.8133 31.0578L38.74 31.7248C38.6721 32.2688 38.5865 32.7758 38.4787 33.1898C38.1899 34.3014 37.3436 35.1703 36.2672 35.4642C35.7767 35.5993 34.9143 35.7004 33.8983 35.776L33.1109 35.8281L32.2865 35.8715L31.0249 35.9219L30.1971 35.9469L28.0025 35.9896L26.1906 36L24.5309 35.9831L23.0237 35.9527L22.0309 35.9238L20.6785 35.8699L19.6326 35.8126L18.9722 35.7663L18.3561 35.713C18.2578 35.7036 18.1618 35.6938 18.0685 35.6836L17.5424 35.6189C17.2156 35.5731 16.9392 35.5217 16.7303 35.4642C15.6552 35.1703 14.8076 34.3014 14.5201 33.1898C14.3695 32.6102 14.2624 31.8483 14.1862 31.0578L14.1282 30.3767L14.0836 29.7032L14.0507 29.0587L14.0192 28.1933L14 27.2009V26.7847L14.0192 25.795L14.0507 24.9319L14.0836 24.289L14.1282 23.617L14.1862 22.9373C14.2624 22.1483 14.3695 21.3875 14.5201 20.8079C14.8076 19.6962 15.6552 18.8273 16.7303 18.5334C16.9392 18.4759 17.2156 18.4246 17.5424 18.3788L18.0685 18.314C18.1618 18.3039 18.2578 18.2941 18.3561 18.2846L18.9722 18.2314L19.6326 18.1851L20.6785 18.1278L21.3942 18.0969L23.0237 18.045L24.7983 18.0107L25.5084 18.0025ZM26.8093 20.5697H26.2017L24.912 20.5811L23.5333 20.6053L22.1187 20.6443L21.1308 20.6819L19.8146 20.7511L18.9708 20.8115L18.4868 20.855L18.0719 20.9004C18.0088 20.9081 17.9488 20.9159 17.892 20.9237L17.5909 20.9711C17.504 20.987 17.4309 21.0031 17.3724 21.0192C17.1621 21.0767 16.9928 21.2508 16.9355 21.4721C16.8055 21.9723 16.7062 22.723 16.6353 23.5866L16.5814 24.3513L16.5411 25.152C16.5355 25.2874 16.5305 25.4235 16.526 25.5599L16.5056 26.3786L16.5001 26.7847V27.1764L16.5051 27.5625L16.5235 28.3393L16.5534 29.1095L16.5952 29.8574L16.649 30.5673C16.719 31.3675 16.8141 32.0584 16.9363 32.5284C16.9928 32.7469 17.1621 32.921 17.3764 32.9796L17.4743 33.0035L17.7337 33.051L18.0731 33.0976L18.4871 33.1429L18.9702 33.1862L19.5167 33.2271L20.4435 33.2829L21.482 33.3303L22.1115 33.3531L23.531 33.3923L24.9106 33.4166L26.5057 33.4289L27.5106 33.4231L29.0166 33.4018C29.5311 33.3919 30.0544 33.3792 30.5754 33.3632L31.7054 33.3227L32.6965 33.2752L33.5793 33.2203L34.3375 33.1593L34.9547 33.0938L35.2798 33.0483C35.3279 33.0406 35.3729 33.0329 35.4147 33.0251L35.6258 32.9783C35.8365 32.9208 36.0058 32.7467 36.0636 32.5241C36.2031 31.9886 36.3074 31.1639 36.3792 30.2179L36.427 29.4884C36.434 29.3639 36.4405 29.2381 36.4465 29.1115L36.4764 28.3432L36.4949 27.5688L36.501 26.9962L36.4949 26.4244L36.4765 25.6501L36.4465 24.8823L36.4046 24.1366C36.3329 23.0424 36.2204 22.0754 36.0632 21.4719C36.0058 21.251 35.8365 21.0769 35.6207 21.018C35.5643 21.0025 35.4942 20.987 35.4111 20.9716L35.1239 20.9258L34.7641 20.8812L34.3366 20.8381L33.8462 20.797L33.0035 20.74L32.3773 20.7058L31.3539 20.6611C30.8379 20.6417 30.3141 20.6257 29.7939 20.6129L28.2561 20.5832L26.8093 20.5697Z",
    fill: "url(#paint2_linear_287_6248)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9414 30.8004V23.1975L30.4771 26.9926L23.9414 30.8004Z",
    fill: "url(#paint3_linear_287_6248)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_6248",
    x1: 0,
    y1: 0,
    x2: 62.1595,
    y2: 11.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_287_6248",
    x1: 0,
    y1: 0,
    x2: 62.1595,
    y2: 11.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_287_6248",
    x1: 14,
    y1: 18,
    x2: 41.7838,
    y2: 25.0877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_287_6248",
    x1: 23.9414,
    y1: 23.1975,
    x2: 31.4893,
    y2: 24.3893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6c5b4d313795894ff57a1ff41ee8b318.svg";
export { ForwardRef as ReactComponent };